import { reduxKey } from './constants';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
import { UserAvatarPopoverStoreSlice } from './types';

const actionHandlers = {
  [initialize.toString()]: (state: UserAvatarPopoverStoreSlice, action) => ({
    ...state,
    isLoading: true,
    isError: false,
  }),

  [requestFailure.toString()]: (
    state: UserAvatarPopoverStoreSlice,
    action
  ) => ({
    ...state,
    isLoading: false,
    isError: true,
  }),
  [requestSuccess.toString()](
    state: UserAvatarPopoverStoreSlice,
    { payload }
  ): UserAvatarPopoverStoreSlice {
    return {
      ...state,
      isLoading: false,
      data: payload.data,
    };
  },
};

const reducers = {
  // need to cast "as string" because of TS
  [reduxKey as string](state = {}, action) {
    const { type, payload } = action;
    if (!actionHandlers[type]) {
      return state;
    }

    const stateKey = payload.username.toLowerCase();
    return {
      ...state,
      [stateKey]: actionHandlers[type](state[stateKey], action),
    };
  },
};

export default reducers;
